import { Box } from "@mui/material";
import { Maybe, User } from "api";
import { Avatar } from "components/FixedHeader/styled";
import TimeAgo from "components/TimeAgo";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Name from "components/Name";

interface CommentHeaderProps {
  user: Maybe<User>;
  createdAt: string;
  actions?: Array<any>;
}

const CommentHeader: FC<CommentHeaderProps> = ({
  children,
  user,
  createdAt,
  actions,
}) => (
  <Header>
    <Link
      to={`/profile/${encodeURI(`${user?.username}`)}`}
      className="avatar-link"
    >
      <Avatar src={user?.avatar?.LowResUri} />
    </Link>
    <Box flex={1} marginLeft={1}>
      <NameContainer>
        <Link to={`/profile/${encodeURI(`${user?.username}`)}`}>
          <Name user={user} />
        </Link>
      </NameContainer>
      <Extra>
        <Link to={`/profile/${encodeURI(`${user?.username}`)}`}>
          @{`${user?.username}`}
        </Link>
        <TimeAgo time={createdAt} />
      </Extra>
    </Box>
    <Box>
      {/* <MoreMenu actions={actions} /> */}
      {children}
    </Box>
  </Header>
);

export default CommentHeader;

const RightArrow = styled.span`
  margin: 0 4px;
  font-size: 15px;
`;

const NameContainer = styled.p`
  font-size: 17px;
  font-weight: 400;
  font-family: "Trebuchet MS", sans-serif;
  line-height: 1;
  color: #131722;
  margin-bottom: 5px;
  a {
    color: inherit;
    text-decoration: none;
    &:first-child {
      white-space: nowrap;
    }
    &:hover {
      color: var(--hover-text-color);
      text-decoration: underline;
    }
    img {
      height: 16px;
      width: 16px;
    }
  }

  @media (max-width: 480px) {
    font-size: 15px;
    a {
      img {
        height: 14px;
        width: 14px;
      }
    }
  }
`;

const Extra = styled.p`
  font-family: "Trebuchet MS", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-color-secondary);

  a {
    color: inherit;
    text-decoration: none;
    &:first-child {
      white-space: nowrap;
    }
    &:hover {
      color: var(--hover-text-color);
      text-decoration: underline;
    }
    margin-right: 4px;
  }
`;

const MediaContainer = styled.div``;

const Container = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 15px 5px 5px 15px;
`;

const Card = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: #f0f2f5;
  margin: 0 0 10px 0;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 8px;

  .MuiAvatar-root {
    width: 36px;
    height: 36px;
  }

  .MuiIconButton-root {
    padding: 6px;

    .MuiSvgIcon-root {
      height: 18px;
      width: 18px;
    }
  }

  p.header-name,
  p.header-subname {
    display: flex;
    align-items: center;
    margin: 0;
    color: var(--text-color-primary);
    font-family: "Trebuchet MS", sans-serif;
    font-size: 16px;
    line-height: 1;
    color: #131722;
    a {
      text-decoration: none;
      line-height: 1;
    }

    a:hover {
      color: var(--hover-text-color);
      text-decoration: underline;
    }
  }

  p.header-name {
    margin-bottom: 5px;
    img {
      height: 14px;
      width: 14px;
    }
    a {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color-primary);
      font-size: 17px;
      font-weight: 400;
      font-family: "Trebuchet MS", sans-serif;
      line-height: 1;
      color: #131722;
    }
    .MuiSvgIcon-root {
      height: 20px;
      width: 20px;
      margin: 0 2px;
    }
  }

  p.header-subname {
    a {
      font-size: 12px;
      font-weight: 600;
      color: var(--text-color-secondary);
    }
  }
`;

// const Header = styled.div`
//   display: flex;
//   align-items: flex-start;
//   padding: 8px;

//   .MuiAvatar-root {
//     width: 32px;
//     height: 32px;
//   }

//   p.header-name,
//   p.header-subname {
//     display: flex;
//     align-items: center;
//     margin: 0;
//     color: var(--text-color-primary);

//     a {
//       text-decoration: none;
//       line-height: 1;
//     }

//     a:hover {
//       color: var(--hover-text-color);
//       text-decoration: underline;
//     }
//   }

//   p.header-name {
//     min-height: 20px;
//     img {
//       height: 12px;
//       width: 12px;
//     }
//     a {
//       font-size: 14px;
//       font-weight: 600;
//       color: var(--text-color-primary);
//     }
//     .MuiSvgIcon-root {
//       height: 20px;
//       width: 20px;
//       margin: 0 2px;
//     }
//   }

//   p.header-subname {
//     a {
//       font-size: 12px;
//       font-weight: 600;
//       color: var(--text-color-secondary);
//     }
//   }
// `;

const Body = styled.div`
  padding: 0 12px 0 48px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2px 12px 4px 48px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Count = styled.span``;

const IconButtonWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
  .MuiIconButton-root {
    padding: 5px;
  }
  svg {
    height: 14px;
    width: 14px;
  }
`;

const WriteYourComment = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  .MuiAvatar-root {
    width: 32px;
    height: 32px;
  }
  .MuiButton-outlined {
    padding: 3px 3px 3px 10px;
    margin-left: 8px;
    border-radius: 25px;
    flex: 1;
    justify-content: flex-start;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-color-secondary);
    background-color: #ffffff;
    text-transform: initial;
  }
`;
